export const amountToNumber = (amount: string) =>
  Number(
    amount
      .toString()
      .replace(/(\$|₦)+/g, '')
      .replace(/(,)+/g, ''),
  )
